export default ['user',
  'anquan',
  'baocun',
  'charutupian',
  'chatou',
  'chaxun',
  'chehuisekuai',
  'ditu-dibiao',
  'fabu',
  'fenlan',
  'gaojing',
  'tixingshixin',
  'gengduo',
  'gongyezujian-kaiguan',
  'gongyezujian-yibiaopan',
  'gongnengdingyi',
  'guanbi',
  'guangbo',
  'jichuguanli',
  'jiedianguanli',
  'jinggao',
  'qiapianmoshi_kuai',
  'kaiguan',
  'kongjianweixuan',
  'kongjianxuanzhong',
  'kongjianyixuan',
  'liebiaomoshi_kuai',
  'quanxianshenpi',
  'shangyibu1',
  'shangyibu',
  'shengyinkai',
  'shimingrenzheng',
  'shoucang',
  'shuaxin',
  'sousuo',
  'tubiao-bingtu',
  'tubiao-zhexiantu',
  'tupiantianjia',
  'weizhigeshi',
  'xiayibu',
  'xiaoxitongzhi',
  'yibiaopan',
  'yunduanshangchuan',
  'yunduanxiazai',
  'zhanghaoquanxianguanli',
  'zidingyi',
  'ishipinshixiao',
  'icon_bangzhuwendang',
  'icon_baocun',
  'icon_shezhi',
  'icon_shiyongwendang',
  'icon_tianjia',
  'icon_wangye',
  'icon_yingyongguanli',
  'icon_yulan',
  'icon_zhanghao',
  'icon_loading'
]



// WEBPACK FOOTER //
// ./src/store/solid.js